import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';

@Component({
  selector: 'app-material-filter',
  templateUrl: './material-filter.component.html',
  styleUrls: ['./material-filter.component.scss']
})
export class MaterialFilterComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public search_array: any = [];
  public type_task!: number;
  public server_main!: string;
  public server!: any;
  public site!: any;
  public user_id!: number;
  public id!: number;
  public i!: number;
  public code!: number;
  public result!: any;
  public creator!: number;
  public expire!: boolean;
  public access_service!: number;
  public level!: number;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public messageService: MessageService,
    public matDialogRef: MatDialogRef<MaterialFilterComponent>) {
    this.server_main = this.serverService.get_server_main();
    this.server = this.serverService.get_server();
    this.site = this.serverService.get_site();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.creator = dialog_data.creator;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          group: dialog_data.search_array.group,
          group_title: dialog_data.search_array.group_title,
          cate: dialog_data.search_array.cate,
          cate_title: dialog_data.search_array.cate_title,
          title: dialog_data.search_array.title,
          price: dialog_data.search_array.price,
          price2: dialog_data.search_array.price2,
          comment: dialog_data.search_array.comment,
          coding: dialog_data.search_array.coding,
        })
      }
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'price': new FormControl(0),
      'price2': new FormControl(0),
      'group_title': new FormControl(null),
      'group': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cate_title': new FormControl(null),
      'cate': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),

    });
  }
  check_access(type_task: any, excel: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, excel, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, excel: number, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.expire = res['expire'];
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            }
          }
          if (type_task == 2) { }
          if (type_task == 3) { this.search(excel); }
          if (type_task == 4) { }
          if (type_task == 5) { }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      price: this.form1_group.value.price,
      price2: this.form1_group.value.price2,
      group_title: this.form1_group.value.group_title,
      group: this.form1_group.value.group,
      cate_title: this.form1_group.value.cate_title,
      cate: this.form1_group.value.cate,
      export_excel: excel
    })
  }
  load_services(id: number): any {
    var creator = this.creator;
    var code_id;
    if (id == 1841) {
      if (!this.form1_group.value.group) {
        var message = "در ابتدا باید گروه انتخاب شود";
        this.message(true, this.messageService.message(message), 1, this.messageService.close());
        return false;
      }
    }
    if (id == 184) {
      code_id = 6523;
    }
    if (id == 223) {
      code_id = 6346;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        'id': id,
        'creator': creator,
        'code_id': code_id,
        obj: { group: this.form1_group.value.group, group2: this.form1_group.value.group2 }
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 223) {
            this.form1_group.patchValue({
              'group': res.id,
              'group_title': res.title,
              'cate': null,
              'cate_title': null
            })
          }
          if (id == 184) {
            this.form1_group.patchValue({
              'cate': res.id,
              'cate_title': res.title
            })
          }
          if (id == 211) {
            this.form1_group.patchValue({
              'weight': res.id,
              'weight_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number): any {
    if (id == 223) {
      this.form1_group.patchValue({
        'group_title': null,
        'group': null,
        'cate': null,
        'cate_title': null
      })
    }
    if (id == 184) {
      this.form1_group.patchValue({
        'cate_title': null,
        'cate': null

      })
    }
    if (id == 211) {
      this.form1_group.patchValue({
        'weight': null,
        'weight_title': null
      })
    }
  }
  //********************************************************************************************* */
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
